import { useCallback } from 'react';

import useQueryParam, { StringParam } from '@/hooks/useQueryParam';

import { UseMultiStepStateType } from './types';

const MULTI_STEP_QUERY_PARAM = 'step';

export default function useQueryParamStep({ formName, initialStep }: UseMultiStepStateType) {
  const queryParam = formName ? `${formName}-${MULTI_STEP_QUERY_PARAM}` : MULTI_STEP_QUERY_PARAM;
  const [inViewStep, setInViewStep] = useQueryParam(queryParam, StringParam);

  const setStep = useCallback(
    (step: string) => {
      setInViewStep(step, 'replace');
    },
    [setInViewStep],
  );

  return {
    inViewStep: inViewStep ?? initialStep,
    setStep,
  };
}
